import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  container: {
    flexGrow: 1,
    display: "flex",
    flexDirection: "column",
    // whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  title: {
    ...theme.typography.rockwell,
    fontSize: theme.typography.pxToRem(20),
    fontWeight: 700,
    margin: theme.spacing(0.4),
    color: theme.palette.common.headerText,
  },
  location: {
    display: "flex",
    alignItems: "center",
    fontSize: theme.typography.pxToRem(12),
    fontWeight: 400,
    color: theme.palette.common.headerText,

  },
  iconBtn: {
    color: theme.palette.common.white,
  },
  blackColor: {
    // color: theme.palette.primary.main
    color: "#000"
  },
  noPadingIcon: {
    padding: theme.spacing(0),
  },
}));

export default useStyles;
